import { keyanLogin } from '@/services/user';
import { isKangeHong } from '@/utils/project';
//todo 需要修改为8小时。
const maxRenewLease = 8 * 60 * 60 * 1000;
let startTime = new Date();
let setTimeoutNumber = 0;

export default function useKeepalive() {
  //最大续租时间为8小时。
  const doAlive = () => {
    if (new Date().valueOf() - startTime.valueOf() < maxRenewLease) {
      console.log("doAlive");
      keyanLogin();
    }
  };
  const doKeepalive = () => {
    //1分钟请求一次。当前如果已经存在定时器，就不重复执行。
    console.log("doKeepalive");
    if (setTimeoutNumber !== 0) {
      console.log("doKeepalive return");
      return;
    }
    setTimeoutNumber = setInterval(doAlive, 60 * 1 * 1000);
  };

  /**
   * @desc 重置定时器。
   */
  const restartKeepalive = () => {
    console.log("restartKeepalive");
    startTime = new Date();
    console.log(startTime);
    if (setTimeoutNumber !== 0) {
        unlockKeepalive();
     }
  };

  const unlockKeepalive = () => {
    clearInterval(setTimeoutNumber);
    setTimeoutNumber = 0;
  };

  (window as any).passportLoginCallback = () => {
    //当康宏项目扫码后需要重启定时器。
    if (isKangeHong()) {
      restartKeepalive();
      doKeepalive();
    }
  };

  return {
    doKeepalive,
    unlockKeepalive,
    restartKeepalive,
  };
}
